<div class="px-4 pt-3 pb-2">
  <h2 class="title-container mt-0">Color Themes</h2>
  <div class="flex-it">
    @for (group of options; track group) {
      <div class="color-palette-select mr-4">
        <h3 class="title-box-themes mt-0">{{ group.group_name }}</h3>
        @for (palette of group.palettes; track palette) {
          <div
            class="flex-it palette"
            (click)="select(palette)"
            [ngClass]="{ active: selected === palette.palette_name }"
          >
            <span class="title-theme">{{ palette.palette_label }}</span>
            @if (palette?.showColors) {
              <div
                class="color-container ml-1"
                [style.background-color]="
                  palette?.background ? showBackground(palette) : 'transparent'
                "
              >
                <div class="color-box-container">
                  @for (color of palette.colors; track color) {
                    @if (!color.hide) {
                      <div class="color-box">
                        <div
                          [style.background-color]="color.hexValue"
                          class="color-square"
                        ></div>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
